import {
  Building2, Users, Sparkles, Cpu, ShoppingCart, CalendarDays, TrendingUp, BookOpen, BookMarked,
  UsersRound, Video, Calculator, MessagesSquare, Rocket, Lightbulb, Library, GraduationCap,
  ShieldCheck, TriangleAlert, Wrench, Tag, FileText, Megaphone, Store, Share2, Palette, Bell,
  Headset, MessageCircle, ListChecks, Zap, Receipt, MapPinned, Wallet,
} from "lucide-react";

export const ACCENTS = {
  franchisee: "#4CCC06",
  franchisee_employee: "#4CCC06",
  admin: "#4CCC06",
  machine_owner: "#FFFFFF",
  rental_customer: "#FFD400",
  prospect: "#FFB347",
  tour: "#4CCC06",
};

export const accentFor = (role) => ACCENTS[role] || ACCENTS.franchisee;

export const ROLE_TABS = [
  { key: "franchisee", icon: Building2, label: "Franchisee Login", eyebrow: "FRANCHISEE PORTAL", subtitle: "Access your full franchisee toolkit." },
  { key: "franchisee_employee", icon: Users, label: "Employee Login", eyebrow: "EMPLOYEE PORTAL", subtitle: "For team members added by their franchise owner." },
  { key: "machine_owner", icon: Cpu, label: "Machine Owner Login", eyebrow: "MACHINE OWNER PORTAL", subtitle: "Access manuals, parts ordering, and your support team." },
  { key: "rental_customer", icon: CalendarDays, label: "Rental Customer", eyebrow: "RENTAL CUSTOMER", subtitle: "Required Laser Safety Officer training for your rental." },
];

export const HELP_TEXT = {
  franchisee: "Authorized franchisees & corporate staff only. Contact ALR Corporate for access.",
  franchisee_employee: "Authorized franchisees & corporate staff only. Contact ALR Corporate for access.",
  machine_owner: "Machine owner accounts are provisioned by ALR Corporate after purchase.",
  rental_customer: "Rental customer accounts are provisioned by ALR Corporate. Need access? Email info@alrclean.com.",
};

const t = (key, title, icon, route) => ({ key, title, icon, route });

export const FRANCHISEE_TILES = [
  t("ai", "ALR Cleaning Agent", Sparkles, "/ai-assistant"),
  t("sales_coach", "AI Sales & Marketing Coach", TrendingUp, "/sales-coach"),
  t("playbook", "ALR Playbook", BookOpen, "/playbook"),
  t("success_guide", "Franchise Success Guide", BookMarked, "/franchise-success-guide"),
  t("employee_guide", "Employee Success Guide", UsersRound, "/employee-success-guide"),
  t("video_studio", "ALR Video Studio", Video, "/video-studio"),
  t("quote_builder", "Project Quote Builder", Calculator, "/sales-coach/quote-builder"),
  t("community", "Franchisee Community", MessagesSquare, "/community"),
  t("launch_training", "Launch Training", Rocket, "/launch-training"),
  t("my_presets", "Laser Cleaning Settings", Lightbulb, "/my-presets"),
  t("laser_machines", "Machines & Calibration", Cpu, "/laser-machines"),
  t("ops", "Operations Manual", Library, "/operations"),
  t("lso", "Laser Safety Training", GraduationCap, "/lso"),
  t("my_lso_cert", "My LSO Training", ShieldCheck, "/my-lso-cert"),
  t("safety_center", "Safety Center", TriangleAlert, "/safety"),
  t("employees", "Manage Employees", UsersRound, "/employees"),
  t("handbook", "Employee Handbook", BookOpen, "/handbook"),
  t("warranty", "Limited Warranty", ShieldCheck, "/warranty"),
  t("equipment_manuals", "Equipment Manuals", Wrench, "/section/equipment_manuals"),
  t("equipment_pricing", "Equipment Pricing", Tag, "/section/equipment_pricing"),
  t("sales_programs", "Sales Programs", TrendingUp, "/section/sales_programs"),
  t("hiring_hr", "Hiring & HR", Users, "/section/hiring_hr"),
  t("safety_resources", "Safety Resources", ShieldCheck, "/section/safety_resources"),
  t("training_videos", "Training Videos", Video, "/section/training_videos"),
  t("forms", "Forms & Submissions", FileText, "/section/forms"),
  t("press_release", "Press Release Form", Megaphone, "/press-release"),
  t("marketing_videos", "Upload Marketing Videos", Video, "/marketing-videos"),
  t("store", "ALR Store", Store, "/store"),
  t("marketing", "Marketing Resources", Megaphone, "/section/marketing"),
  t("social_media", "Social Media Guide", Share2, "/section/social_media"),
  t("brand_standards", "Brand Standards", Palette, "/section/brand_standards"),
  t("updates", "Corporate Updates", Bell, "/section/updates"),
  t("support", "Support / Contact", Headset, "/support"),
  t("feedback", "Suggest a Feature", Lightbulb, "/feedback"),
];

export const MACHINE_OWNER_TILES = [
  t("ai", "ALR Cleaning Helper", Sparkles, "/ai-assistant"),
  t("community", "Community Chat", MessageCircle, "/customer-community"),
  t("cleaning_settings_public", "Laser Cleaning Settings", Lightbulb, "/cleaning-settings"),
  t("lso", "Laser Safety Training", GraduationCap, "/lso"),
  t("equipment_manuals", "Equipment Manuals", Wrench, "/section/equipment_manuals"),
  t("warranty", "Limited Warranty", ShieldCheck, "/warranty"),
  t("safety_resources", "Safety Resources", ShieldCheck, "/section/safety_resources"),
  t("customer_team", "My Team", UsersRound, "/customer-team"),
  t("support", "Support / Contact", Headset, "/support"),
  t("feedback", "Suggest a Feature", Lightbulb, "/feedback"),
];

export const EMPLOYEE_TILES = [
  t("onboarding", "My Onboarding", ListChecks, "/employee-onboarding"),
  t("ai", "ALR Cleaning Agent", Sparkles, "/ai-assistant"),
  t("sales_coach", "AI Sales & Marketing Coach", TrendingUp, "/sales-coach"),
  t("playbook", "ALR Playbook", BookOpen, "/playbook"),
  t("quote_builder", "Project Quote Builder", Calculator, "/sales-coach/quote-builder"),
  t("marketing_videos", "Upload Marketing Videos", Video, "/marketing-videos"),
  t("success_guide", "Franchise Success Guide", BookMarked, "/franchise-success-guide"),
  t("employee_guide", "Field Operator's Playbook", UsersRound, "/employee-success-guide"),
  t("video_studio", "ALR Video Studio", Video, "/video-studio"),
  t("my_presets", "Laser Cleaning Settings", Lightbulb, "/my-presets"),
  t("laser_machines", "Machines & Calibration", Cpu, "/laser-machines"),
  t("lso", "Laser Safety Training", GraduationCap, "/lso"),
  t("my_lso_cert", "My LSO Training", ShieldCheck, "/my-lso-cert"),
  t("safety_center", "Safety Center", TriangleAlert, "/safety"),
  t("handbook", "Employee Handbook", BookOpen, "/handbook"),
  t("warranty", "Limited Warranty", ShieldCheck, "/warranty"),
  t("equipment_manuals", "Equipment Manuals", Wrench, "/section/equipment_manuals"),
  t("training_videos", "Training Videos", Video, "/section/training_videos"),
  t("support", "Support / Contact", Headset, "/support"),
  t("feedback", "Suggest a Feature", Lightbulb, "/feedback"),
];

const ADMIN_EXTRAS = [
  t("laser_app", "Laser Software", Zap, "/admin/laser-cleaning-app"),
  t("territory_lockouts", "Territory & Lockouts", MapPinned, "/admin/territory"),
  t("equipment_sales", "Equipment Sales", Receipt, "/equipment-sales"),
  t("admin_billing", "Franchisee Invoicing", Wallet, "/admin/billing"),
  t("agreements", "Franchise Agreements", FileText, "/admin/agreements"),
  t("bookkeeping", "Bookkeeping", Calculator, "/bookkeeping"),
  t("admin_marketing_videos", "Marketing Videos (Drive)", Video, "/admin/marketing-videos"),
];

export const BILLING_TILE = t("billing", "Invoicing & Payments", Wallet, "/billing");

export const AI_PIN_ORDER = ["ai", "sales_coach"];
export const FEATURED_TILES = ["marketing_videos", "quote_builder", "billing"];

export function tilesForUser(user) {
  if (user.role === "machine_owner") {
    return user.parent_owner_id ? MACHINE_OWNER_TILES.filter((x) => x.key !== "customer_team") : MACHINE_OWNER_TILES;
  }
  if (user.role === "franchisee_employee") {
    const feats = user.employee_features || {};
    return EMPLOYEE_TILES.filter((x) => (x.key === "laser_machines" ? feats.my_presets !== false : !(x.key in feats) || feats[x.key]));
  }
  if (user.role === "admin") return [...ADMIN_EXTRAS, ...FRANCHISEE_TILES];
  const extra = (user.permissions || []).includes("equipment_sales") ? [ADMIN_EXTRAS[2]] : [];
  return [...extra, ...FRANCHISEE_TILES];
}

export function applyCustomOrder(tiles, order) {
  const pinned = AI_PIN_ORDER.map((k) => tiles.find((x) => x.key === k)).filter(Boolean);
  const rest = tiles.filter((x) => !AI_PIN_ORDER.includes(x.key));
  if (!order?.length) {
    const featured = FEATURED_TILES.map((k) => rest.find((x) => x.key === k)).filter(Boolean);
    return [...pinned, ...featured, ...rest.filter((x) => !FEATURED_TILES.includes(x.key))];
  }
  const byKey = new Map(rest.map((x) => [x.key, x]));
  const ordered = [...new Set(order)].map((k) => byKey.get(k)).filter(Boolean);
  return [...pinned, ...ordered, ...rest.filter((x) => !order.includes(x.key))];
}

export function homeRouteFor(user) {
  if (user.role === "rental_customer") return "/lso-rental";
  return "/dashboard";
}

export const PORTAL_LABEL = {
  machine_owner: "MACHINE OWNER",
  franchisee_employee: "FRANCHISEE EMPLOYEE",
  admin: "CORPORATE ADMIN",
  franchisee: "FRANCHISEE PORTAL",
};

// Which rebuild phase brings each screen over (from the migration kit).
const PHASE_RULES = [
  [/^\/(tour|admin)/, 5, "Guided tour & remaining admin tools"],
];

export function phaseForPath(path) {
  for (const [re, phase, label] of PHASE_RULES) if (re.test(path)) return { phase, label };
  return { phase: null, label: "Additional tools" };
}
